import { useEffect } from "react";
import { Icon } from "../../components/Icon";
import { FlexBody } from "./FlexBody";
import { ShopBody } from "./ShopBody";

// Order-type discriminator. The unified order list carries the row's type so
// the drawer can pick the matching body without an extra detail round-trip.
//
// Тип «Ozon/WB» удалён 2026-06-12: детальная карточка Ozon/WB-заказа
// со статус-флоу, печатью наклеек и паспортом) заархивирован в ветке
// Сервер не отдаёт строки архивных направлений (PR5 в main); заглушка для
// неизвестного типа — защита в глубину (архив archive/ozonwb-flow).
export type OrderDrawerType = "flex" | "shop";

export function OrderDrawer({
  id,
  type,
  onClose,
}: {
  id: string;
  type?: OrderDrawerType;
  onClose: () => void;
}) {
  if (type === "flex") return <FlexBody key={id} id={id} onClose={onClose} />;
  if (type === "shop") return <ShopBody key={id} id={id} onClose={onClose} />;
  return <UnsupportedTypeBody onClose={onClose} />;
}

/** Neutral fallback drawer for unknown/legacy order types. */
function UnsupportedTypeBody({ onClose }: { onClose: () => void }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="drawer-overlay" onClick={onClose}>
      <div className="drawer" onClick={(e) => e.stopPropagation()}>
        <div className="drawer-head">
          <button className="btn-admin ghost" aria-label="Закрыть заказ" onClick={onClose}>
            <Icon name="close" />
          </button>
          <h2>Заказ</h2>
        </div>
        <div className="drawer-body">
          <p className="muted" style={{ padding: 8 }}>
            Тип не поддерживается
          </p>
        </div>
      </div>
    </div>
  );
}
